import { render } from "./RemoveConfirm.vue?vue&type=template&id=b51a1bae"
import script from "./RemoveConfirm.vue?vue&type=script&lang=js"
export * from "./RemoveConfirm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__